<template>
  <div class="card shadow-sm table-card mb-4" v-if="visible">
    <div class="form-card-header">
      <div class="section-number"><i class="fe fe-alert-triangle" style="font-size: 12px;"></i></div>
      <div class="flex-grow-1">
        <h6 class="mb-0 font-weight-bold text-white">Fraud signals</h6>
        <small style="color: rgba(255,255,255,.75);">Local rules and HIVA TRACE; they flag the claim for a closer look, nothing is changed</small>
      </div>
      <span v-if="data" class="sev" :class="'sev-' + data.level">{{ data.level === "none" ? "No signals" : data.level + " risk" }}</span>
    </div>
    <div class="card-body">
      <div v-if="loading" class="text-muted small"><i class="mdi mdi-loading mdi-spin"></i> Checking…</div>
      <div v-else-if="error" class="text-muted small">{{ error }}</div>
      <div v-else-if="data && !data.signals.length" class="text-muted small"><i class="fe fe-check-circle text-success mr-1"></i> No duplicate, frequency, amount, facility or HIVA warnings for this claim.</div>
      <div v-else-if="data">
        <div v-for="s in data.signals" :key="s.key" class="d-flex mb-3" style="gap: 10px;">
          <span class="sev align-self-start" :class="'sev-' + s.severity">{{ s.severity }}</span>
          <div>
            <b>{{ s.title }}</b>
            <div class="small text-muted">{{ s.message }}</div>
            <div v-if="s.claims" class="small mt-1">
              <router-link v-for="c in s.claims" :key="c.id" :to="`/claim/${c.id}`" class="mr-2">{{ c.claim }} ({{ c.seen_date }})</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Fraud signals of one claim (GET claims/{id}/fraud-signals); agency staff only. */
export default {
  name: "FraudSignals",
  props: { claimId: { type: [Number, String], required: true } },
  data() {
    const user = JSON.parse(localStorage.getItem("user") || "{}") || {};
    return { visible: ["shis", "employee"].includes(user.type), data: null, loading: false, error: "" };
  },
  watch: { claimId() { this.load(); } },
  mounted() { this.load(); },
  methods: {
    load() {
      if (!this.visible || !this.claimId) return;
      this.loading = true;
      this.error = "";
      this.axios
        .get(`/api/v1/auth/claims/${this.claimId}/fraud-signals`)
        .then((res) => { this.data = res.data.data; })
        .catch((e) => { this.error = (e.response && e.response.data && e.response.data.message) || "Could not check this claim."; })
        .finally(() => { this.loading = false; });
    },
  },
};
</script>

<style scoped>
@import "../reports.css";
</style>
